import { theme } from '@/styles/theme';

export const styles = {
  container: {
    display: 'flex',
    height: '60vh',
    width: '100%',
    overflowY: 'auto',
    paddingTop: '20px',
    alignContent: 'center',
  },
  subTitle: {
    fontSize: '1.8rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
    paddingTop: '1.6rem',
    whiteSpace: 'pre-line',
    width: '100vh',
  },
  minContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    // minHeight: '100vh',
    // padding: theme.spacing(2),
  },
  minContent: {
    backgroundColor: theme.palette.secondary.contrastText,
    borderRadius: 2,
    maxWidth: 711,
    boxShadow: 1,
    paddingInline: 4,
    marginTop: 4,
    paddingBlock: 4,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      paddingInline: 2,
      marginTop: 2,
      paddingBlock: 2,
    },
    [theme.breakpoints.up('md')]: {
      paddingInline: 4,
      marginTop: 4,
      paddingBlock: 4,
    },
  },
  minHeader: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 2,
  },
  warningBox: { marginBottom: 2, marginTop: 2 },
};
